var _g, _g2, _path, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 141,
    viewBox: "0 0 224 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_351_230)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14.0435,
    width: 180,
    height: 106.957,
    rx: 24,
    fill: "#5FC56E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_351_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.107 81.2864C110.084 83.2151 113.916 83.2151 116.893 81.2864L183.443 38.173C190.968 33.2981 187.516 21.6196 178.55 21.6196H45.4504C36.4844 21.6196 33.0321 33.2981 40.557 38.173L107.107 81.2864Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.597 61.283C140.778 61.2884 141.996 61.3476 143.234 61.4483C140.525 62.9456 136.401 64.6666 132.314 65.9239C129.488 66.7935 126.663 67.473 124.325 67.8055C122.884 68.0103 121.662 68.0326 120.759 67.966C122.121 65.8594 124.917 63.977 128.853 62.7558C131.76 61.8537 135.247 61.3184 139.093 61.2841C139.261 61.2826 139.429 61.2822 139.597 61.283ZM84.4031 61.283C84.5711 61.2822 84.739 61.2826 84.907 61.2841C88.7534 61.3184 92.24 61.8539 95.1474 62.7558C99.0832 63.977 101.879 65.8594 103.241 67.966C102.338 68.0326 101.116 68.0103 99.6753 67.8055C97.3371 67.473 94.5121 66.7935 91.6858 65.9239C87.5993 64.6665 83.4756 62.9456 80.766 61.4483C82.0045 61.3477 83.2219 61.2884 84.4031 61.283ZM144.589 63.499C143.043 71.5254 143.181 82.6349 145 90.1132C139.919 90.7162 134.364 89.799 129.755 88.2234C127.251 87.3673 125.029 86.3262 123.331 85.2813C122.714 84.9014 122.176 84.5191 121.717 84.1514C121.884 84.0067 122.044 83.8565 122.198 83.701C124.336 81.5338 124.771 78.4314 124.219 75.498C123.875 73.6666 123.147 71.8686 122.072 70.3368C125.672 70.3925 129.926 69.4061 134.055 68.0689C138.029 66.7816 141.794 65.1549 144.589 63.499ZM79.4111 63.499C82.2061 65.1549 85.9706 66.7816 89.9451 68.0689C94.0737 69.4061 98.3285 70.3925 101.928 70.3368C100.853 71.8686 100.125 73.6666 99.7807 75.498C99.2295 78.4314 99.6636 81.5338 101.802 83.701C101.956 83.8565 102.116 84.0067 102.283 84.1514C101.824 84.5191 101.286 84.9015 100.669 85.2813C98.9712 86.3262 96.7492 87.3673 94.2448 88.2234C89.636 89.799 84.0812 90.7162 79 90.1132C80.819 82.6349 80.957 71.5254 79.4111 63.499ZM112 67.9208C114.334 67.9208 116.642 68.5486 118.065 69.6331C119.801 70.9572 121.196 73.3959 121.661 75.8694C122.126 78.3431 121.66 80.7673 120.239 82.2077C118.587 83.8822 115.324 84.8757 112 84.8757C108.676 84.8757 105.413 83.8822 103.761 82.2077C102.34 80.7673 101.874 78.3431 102.339 75.8694C102.804 73.3959 104.198 70.9572 105.935 69.6331C107.358 68.5486 109.666 67.9208 112 67.9208ZM119.591 85.5539C120.236 86.0961 120.993 86.6248 121.844 87.1486C123.747 88.3196 126.134 89.4312 128.815 90.3478C129.044 90.4259 129.275 90.5022 129.508 90.5774C132.501 98.834 137.07 106.792 141.77 113.873C140.552 113.633 139.041 113.27 137.507 112.78C134.445 111.801 131.125 110.311 129.05 108.487L127.408 107.043L126.872 109.029C125.782 113.066 123.689 115.129 121.436 117.435C116.349 109.202 114.058 98.3722 113.473 87.1038C115.656 86.9516 117.792 86.4536 119.591 85.5539H119.591ZM104.409 85.5539C106.208 86.4536 108.344 86.9516 110.527 87.1038C109.942 98.3722 107.651 109.202 102.564 117.435C100.311 115.129 98.2181 113.066 97.1283 109.029L96.5924 107.043L94.9503 108.487C92.8749 110.311 89.5554 111.801 86.4932 112.78C84.9594 113.27 83.4481 113.633 82.2301 113.873C86.9296 106.793 91.4993 98.834 94.4921 90.5774C94.7248 90.5022 94.9559 90.4259 95.1845 90.3478C97.8658 89.4312 100.253 88.3196 102.156 87.1486C103.008 86.6248 103.764 86.0961 104.409 85.5539H104.409Z",
    fill: "#F22F2F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 23,
    r: 20,
    fill: "#F22F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.256 23.08V26.248H184.504V31H181.336V26.248H176.584V23.08H181.336V18.328H184.504V23.08H189.256ZM205.82 27.304V31H193.364V27.304H197.276V19.84H193.364V17.056C194.436 16.992 195.636 16.712 196.964 16.216C198.292 15.704 199.452 15.12 200.444 14.464H202.052V27.304H205.82Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_351_230",
    x: 16.3,
    y: 10.3435,
    width: 203.4,
    height: 130.357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_351_230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_351_230",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_351_230",
    x: 28.0341,
    y: 18.2196,
    width: 167.932,
    height: 77.9134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_351_230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_351_230",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetters);
export default __webpack_public_path__ + "static/media/letters.8c335c18051ad249912fea77b9458fcb.svg";
export { ForwardRef as ReactComponent };